import { TuiHintModule } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'iss-circle-icon-button',
  templateUrl: './circle-icon-button.component.html',
  styleUrls: [ './circle-icon-button.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    TuiHintModule,
  ],
})
export class CircleIconButtonComponent {
  @Input({ required: true }) public name!: IconName;
  @Input() public size: 'large' | 'small' = 'large';
  @Input() public tooltip?: string;

  @HostBinding('class.iss-small')
  public get isSmall(): boolean {
    return this.size === 'small';
  }
}
